import React, { useEffect, useState } from 'react';
import { auth } from '../config/firebase-config';
import { signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword } from 'firebase/auth';
import { FaGoogle, FaMicrosoft, FaEyeSlash, FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../styles/loginwithsignup.css';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import axios from 'axios';

const LoginPage = () => {
  const [isRightPanelActive, setIsRightPanelActive] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false || window.localStorage.getItem("auth") === 'true');
  const [token, setToken] = useState('');
  const [isHiddenPassword, setIsHiddenPassword] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [FullName, setFullName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    setIsRightPanelActive(true);
  };

  const handleSignInClick = () => {
    setIsRightPanelActive(false);
  };

  const handlePasswordResetRedirect = () => {
    navigate('/password-reset');
  };

  useEffect(() => {
    console.log(process.env.REACT_APP_SERVER_URL);
    
    const unsubscribe = auth.onAuthStateChanged((userCred) => {
      if (userCred) {
        userCred.getIdToken()
          .then(token => {
            setToken(token);
            if (userCred.emailVerified) {
              setIsAuthenticated(true);
              window.localStorage.setItem("auth", "true");
              window.localStorage.setItem("user", JSON.stringify(userCred));
              navigate('/user-redirection', { state: { token } });
            }
          })
          .catch(err => {
            console.log("Error", err);
          });
      } else {
        setIsAuthenticated(false);
        window.localStorage.setItem("auth", "false");
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [navigate]);

  const loginWithGoogle = () => {
    signInWithPopup(auth, new GoogleAuthProvider())
      .then((userCred) => {
        console.log(userCred);
        const isNewUser = userCred._tokenResponse.isNewUser;
        console.log(isNewUser);
        
        userCred.user.getIdToken().then(token => {
          setToken(token);
          console.log(token);
          
          if(isNewUser){
            navigate('/user-type-selection',{ state: { token } });

          }
          else{
            navigate('/user-redirection', { state: { token } });

          }
        });
      })
      .catch((error) => {
        setError("Error during sign in with Google: " + error.message);
        console.error(error);
      });
  };

  const togglePasswordVisibility = () => {
    setIsHiddenPassword(!isHiddenPassword);
  };

  const handleLogin = async (e, type) => {
    e.preventDefault();
    if (type === 'signin') {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        const token = await user.getIdToken();
        setToken(token);

        const res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/loginWithEmailPassword`, {}, {
          headers: { Authorization: 'Bearer ' + token }
        });

        if (res) {
          console.log(res.data);
          navigate('/user-redirection', { state: { token } });
        }
      } catch (error) {
        setError('Invalid email or password');
        console.error(error);
      }
    }
  };

  console.log(process.env.REACT_APP_CLIENT_URL);

  const handleSignUp = async (e) => {
    e.preventDefault();
    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, password);
      await sendEmailVerification(userCred.user);
      
      // Get and store the token
      const token = await userCred.user.getIdToken();
      
      // Store both token and FullName in localStorage
      localStorage.setItem('authToken', token);
      localStorage.setItem('fullName', FullName);
      
      navigate('/verify-email', { 
        state: { 
          FullName, 
          email,
          token
        } 
      });
    } catch (err) {
      // Handle specific error cases
      if (err.code === 'auth/email-already-in-use') {
        try {
          // If email exists, try to sign in
          const userCred = await signInWithEmailAndPassword(auth, email, password);
          if (!userCred.user.emailVerified) {
            // User exists but not verified
            await sendEmailVerification(userCred.user);
            navigate('/verify-email', { 
              state: { 
                FullName, 
                email 
              } 
            });
          } else {
            // User exists and is verified
            setError('Account already exists and is verified. Please sign in.');
            handleSignInClick();
          }
        } catch (signInError) {
          setError('Email already registered. Please use correct password or reset it.');
        }
      } else if (err.code === 'auth/invalid-email') {
        setError('Invalid email address');
      } else if (err.code === 'auth/weak-password') {
        setError('Password should be at least 6 characters');
      } else {
        setError(err.message);
      }
      console.error(err);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="login-signup-page">
        <div className="header">
        </div>
        <div className={`container ${isRightPanelActive ? 'right-panel-active' : ''}`} id="container">
          <div className="button-container">
            <button className={`toggle-btn ${!isRightPanelActive ? "active" : ""}`} onClick={handleSignInClick}>
              Sign In
            </button>
            <button className={`toggle-btn ${isRightPanelActive ? "active" : ""}`} onClick={handleSignUpClick}>
              Sign Up
            </button>
            <div className={`slider ${isRightPanelActive ? "slide-right" : "slide-left"}`}></div>
          </div>

          <div className="form-container">
            <div className={`form ${!isRightPanelActive ? "active-form" : ""}`}>
              {/* Sign In Form */}
              <form onSubmit={(e) => handleLogin(e, 'signin')}>
                <h1>Sign in</h1>
                <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                <div className="password-container">
                  <input type={isHiddenPassword ? 'password' : 'text'} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                  <div className="password-icon" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
                    {isHiddenPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>
                <a href="#" onClick={handlePasswordResetRedirect}>Forgot your password?</a>
                <button className="sign-in-btn">Sign In</button>
                {error && <p>{error}</p>}
                <div className="separator">
                  <hr className="left-dash" />
                  <span className="or-text">or</span>
                  <hr className="right-dash" />
                </div>
                <button className="social-button" onClick={loginWithGoogle}>
                  <FaGoogle style={{ marginRight: '10px' }} /> Sign in with Google
                </button>
                <button className="social-button">
                  <FaMicrosoft style={{ marginRight: '10px' }} /> Sign in with Microsoft
                </button>
                <p>
                  Don't have an account? <span className="sign-up-link" onClick={handleSignUpClick}>Sign up</span>
                </p>
              </form>
            </div>

            <div className={`form ${isRightPanelActive ? "active-form" : ""}`}>
              {/* Sign Up Form */}
              <form onSubmit={handleSignUp}>
                <h1>Create Account</h1>
                <div className="social-container">
                  <a href="#" className="social" onClick={loginWithGoogle}><FaGoogle /></a>
                  <a href="#" className="social"><FaMicrosoft /></a>
                </div>
                <span>or use your email for registration</span>
                <input type="text" placeholder="Full Name" value={FullName} onChange={(e) => setFullName(e.target.value)} required />
                <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                <div className="password-container">
                  <input type={isHiddenPassword ? 'password' : 'text'} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                  <div className="password-icon" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
                    {isHiddenPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>
                <button className="sign-in-btn">Sign Up</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null; // Return nothing while checking the authentication state
};

export default LoginPage;
